import { useMobileDocumentScrollLock } from './useMobileDocumentScrollLock'

export function usePlatformMobileScrollLock(active = true) {
  useMobileDocumentScrollLock(active, 'platform')
}
